exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#free-terms-list .terms-container[data-v-21026897]{display:flex;flex-flow:column;align-items:center}#free-terms-list .empty-results[data-v-21026897]{padding-left:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-21026897&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FreeTermsList.vue
// module id = 150
// module chunks = 0